import { FormInstance, message, Modal } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { contractService } from '../../../services/contractService';

interface DetailHandlersProps {
  id: string;
  form: FormInstance;
  navigate: NavigateFunction;
}

interface DetailHandlers {
  handleOnClickAddButtonClick: () => Promise<void>;
  handleOnClickEditButtonClick: () => Promise<void>;
  handleOnClickDeleteButtonClick: (id: number) => Promise<void>;
}

const detailHandlers = ({ id, form, navigate }: DetailHandlersProps): DetailHandlers => {
  const handleOnClickAddButtonClick = async (): Promise<void> => {
    try {
      // 폼 유효성 검사 - 실패하면 여기서 에러 발생
      await form.validateFields();

      // 유효성 검사 통과 후 로딩 메시지 표시
      const loadingMessage = message.loading('Creating...', 0);

      const contract = form.getFieldsValue();
      // licensor를 제외한 모든 필드에서 null/undefined/빈 문자열 값 제거
      Object.keys(contract).forEach(key => {
        if (
          key !== 'licensor' &&
          (contract[key] === null || contract[key] === undefined || contract[key] === '')
        ) {
          delete contract[key];
        }
      });
      await contractService.create(contract);
      loadingMessage();
      navigate('/contract');
    } catch (error) {
      message.destroy();

      // 유효성 검사 에러인 경우
      if (error && typeof error === 'object' && 'errorFields' in error) {
        Modal.error({
          title: 'Error',
          content: 'Please fill in all required fields.',
          okText: 'Confirm',
        });
        return;
      }

      // API 에러인 경우
      Modal.error({
        title: 'Error',
        content: 'Failed to create : ' + error,
        okText: 'Confirm',
      });
    }
  };

  const handleOnClickEditButtonClick = async (): Promise<void> => {
    try {
      // 폼 유효성 검사 - 실패하면 여기서 에러 발생
      await form.validateFields();

      // 유효성 검사 통과 후 로딩 메시지 표시
      const loadingMessage = message.loading('Updating...', 0);

      const contract = form.getFieldsValue();
      Object.keys(contract).forEach(key => {
        if (
          key !== 'licensor' &&
          (contract[key] === null || contract[key] === undefined || contract[key] === '')
        ) {
          delete contract[key];
        }
      });
      await contractService.update(Number(id), contract);
      loadingMessage();
      navigate('/contract');
    } catch (error) {
      message.destroy();

      // 유효성 검사 에러인 경우
      if (error && typeof error === 'object' && 'errorFields' in error) {
        Modal.error({
          title: 'Error',
          content: 'Please fill in all required fields.',
          okText: 'Confirm',
        });
        return;
      }

      // API 에러인 경우
      Modal.error({
        title: 'Error',
        content: 'Failed to update : ' + error,
        okText: 'Confirm',
      });
    }
  };

  const handleOnClickDeleteButtonClick = async (): Promise<void> => {
    message.info('You do not have permission');
    return;
  };

  return {
    handleOnClickAddButtonClick,
    handleOnClickEditButtonClick,
    handleOnClickDeleteButtonClick,
  };
};

export default detailHandlers;
